import * as React from "react"
const PipeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#fff" clipPath="url(#a)">
      <path d="M21.891 2.109a6.573 6.573 0 0 0-9.282 0l-10.5 10.5a6.57 6.57 0 0 0 0 9.282A6.547 6.547 0 0 0 6.75 23.81c1.682 0 3.36-.641 4.641-1.92l10.5-10.5a6.57 6.57 0 0 0 0-9.281ZM2.906 21.095a5.445 5.445 0 0 1 0-7.69 5.42 5.42 0 0 1 3.844-1.59c1.392 0 2.786.53 3.845 1.59a5.445 5.445 0 0 1 0 7.69 5.445 5.445 0 0 1-7.69 0Zm8.485-8.486a6.564 6.564 0 0 0-5.892-1.799l7.905-7.905a5.445 5.445 0 0 1 7.69 0 5.445 5.445 0 0 1 0 7.69L13.19 18.5a6.56 6.56 0 0 0-1.798-5.891Z" />
      <path d="M9.8 14.2c-1.63-1.628-4.47-1.628-6.1 0a4.284 4.284 0 0 0-1.263 3.05 4.29 4.29 0 0 0 1.264 3.05 4.282 4.282 0 0 0 3.049 1.262A4.29 4.29 0 0 0 9.8 20.3a4.282 4.282 0 0 0 1.262-3.049A4.29 4.29 0 0 0 9.8 14.2Zm-.796 5.303c-1.204 1.204-3.304 1.204-4.507 0a3.16 3.16 0 0 1-.934-2.253c0-.85.331-1.652.934-2.253a3.17 3.17 0 0 1 2.253-.934c.85 0 1.652.331 2.253.934a3.17 3.17 0 0 1 .934 2.253c0 .85-.33 1.651-.932 2.253Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default PipeIcon